import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    to: { name: 'MediaDetail', params: { slug: _ctx.media.slug } },
    image: _ctx.media.poster,
    title: _ctx.media.title,
    date: _ctx.media.premierDate,
    type: _ctx.media.type,
    mediaId: _ctx.media.mediaId
  }, null, 8, ["to", "image", "title", "date", "type", "mediaId"]))
}